import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthProvider';

/**
 * Route guard for the owner-only /admin area. Renders nothing while the
 * session is still loading, redirects non-owners (and anonymous users) to the
 * app root, and otherwise renders the nested admin routes. Kept invisible /
 * redirecting so admin content never flickers for non-owners.
 */
export function IsOwnerGate() {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) return null;
  if (!isAuthenticated || !user?.isOwner) return <Navigate to="/" replace />;
  return <Outlet />;
}
